import React, { Component } from "react";

class Toast extends Component {
  render() {
    return (
      <div>
        <div
          className="position-fixed bottom-0 end-0 p-3"
          style={{ zIndex: 11 }}
        >
          <div
            className="toast bg-cream show"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
          >
            <div className="toast-header">
              <strong className="me-auto">{this.props.name}</strong>
              <small>Just now</small>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="toast"
                aria-label="Close"
                onClick={this.props.hide}
              ></button>
            </div>
            <div className="toast-body font-poppins">{this.props.message}</div>
          </div>
        </div>
      </div>
    );
  }
}
export default Toast;
